<!-- Ported from the Polaris kit: src/components/ui/command/CommandInput.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Polaris patch (woot, phase P): `reset-base` opts out of the app's global `input[type]` rule (_base.scss), which
     boxed the field a second time. A re-port drops it: re-apply. -->
<script setup>
import { Search16 as Search } from '@carbon/icons-vue';
import { reactiveOmit } from '@vueuse/core';
import { ListboxFilter, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';
import { useCommand } from '.';

const props = defineProps({
  modelValue: { type: String, required: false },
  autoFocus: { type: Boolean, required: false },
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

defineOptions({
  inheritAttrs: false,
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);

const { filterState } = useCommand();
</script>

<template>
  <div
    data-slot="command-input-wrapper"
    class="flex h-9 items-center gap-2 border-b border-solid border-polaris-border px-3"
  >
    <Search class="size-4 shrink-0 opacity-50 p-0" />
    <ListboxFilter
      v-bind="{ ...forwardedProps, ...$attrs }"
      v-model="filterState.search"
      data-slot="command-input"
      auto-focus
      :class="
        cn(
          'reset-base placeholder:text-polaris-muted-foreground flex h-10 w-full rounded-polaris-md bg-transparent py-3 type-polaris-body outline-none disabled:cursor-not-allowed disabled:opacity-50',
          props.class
        )
      "
    />
  </div>
</template>
